import { getAccessToken } from '@/shared/utils/tokenHelper';
import { getUserStoreSafe } from '@/shared/utils/piniaSafe.util';

const isUseCookies = process.env.VUE_APP_USE_COOKIES === 'true';

/**
 * Whether the browser has a usable JWT in storage.
 */
export function hasValidAccessToken() {
  const token = getAccessToken();
  return !!(token && token !== 'null' && token !== 'undefined' && String(token).trim());
}

/**
 * True when the user should be treated as anonymous in the UI/API layer.
 * Mirrors router guard logic: cookie sessions use hydrated user profile.
 */
export function isGuestSession() {
  if (isUseCookies) {
    const store = getUserStoreSafe();
    return !(store?.isUserFetched && store?.getUser()?.id);
  }
  return !hasValidAccessToken();
}

/** User id available from login or cache hydration (may precede isUserFetched). */
export function hasKnownUserProfile() {
  const store = getUserStoreSafe();
  return !!(store?.getUser()?.id);
}

/** Logged-in users should see authenticated post detail, not guest preview. */
export function shouldUseAuthenticatedPostDetail() {
  if (hasKnownUserProfile()) return true;
  if (isUseCookies) {
    const store = getUserStoreSafe();
    return !!(store?.isUserFetched && store?.getUser()?.id);
  }
  // JWT: token presence alone is not enough (stale token on shared /post links)
  return false;
}
